export default __webpack_public_path__ + "static/media/review-4.50c2cb6c.jpeg";